import React, { FunctionComponent, forwardRef } from 'react';
import ParentComponent, {
  TParentComponentProps,
} from '@views/components/common/ParentComponent';

export const CartProductName: FunctionComponent<TParentComponentProps> = (
  props
) => {
  return <ParentComponent {...props} />;
};

CartProductName.defaultProps = {
  defaultClassName: 'cart-product__name',
  as: 'a',
};

export default CartProductName;
